import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["moonIcon", "sunIcon"]

  connect() {
    const savedTheme = localStorage.getItem("theme") || "light"
    this.applyTheme(savedTheme)
  }

  toggle() {
    const isDark = document.documentElement.classList.contains("dark")
    const newTheme = isDark ? "light" : "dark"
    this.applyTheme(newTheme)
    localStorage.setItem("theme", newTheme)
  }

  applyTheme(theme) {
    if (theme === "dark") {
      document.documentElement.classList.add("dark")
      this.moonIconTarget.style.display = "none"
      this.sunIconTarget.style.display = "inline"
    } else {
      document.documentElement.classList.remove("dark")
      this.moonIconTarget.style.display = "inline"
      this.sunIconTarget.style.display = "none"
    }
  }
}
